module.exports = require("./es-UY");